import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import PublicNavbar from "@/components/layout/PublicNavbar";

export default function ReceptionistsPage() {
  return (
    <>
      <PublicNavbar />
      <div className="min-h-screen bg-background text-foreground pt-16">
        <div className="py-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="text-primary">AI Virtual</span>{" "}
              Receptionist
            </h1>
            <p className="text-xl text-muted-foreground mb-12">
              Transform your front desk operations with AI receptionists that
              can handle calls, schedule appointments, and manage visitor
              interactions.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="bg-card border border-border p-8 rounded-xl">
                <h2 className="text-2xl font-bold mb-4">Key Features</h2>
                <ul className="space-y-4">
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-primary mr-3"></div>
                    <span>Call handling</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-primary mr-3"></div>
                    <span>Appointment scheduling</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-primary mr-3"></div>
                    <span>Visitor management</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-primary mr-3"></div>
                    <span>Message taking</span>
                  </li>
                </ul>
              </div>

              <div className="bg-card border border-border p-8 rounded-xl">
                <h2 className="text-2xl font-bold mb-4">Benefits</h2>
                <ul className="space-y-4">
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-muted-foreground mr-3"></div>
                    <span>24/7 availability</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-muted-foreground mr-3"></div>
                    <span>Cost reduction</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-muted-foreground mr-3"></div>
                    <span>Improved efficiency</span>
                  </li>
                  <li className="flex items-center">
                    <div className="h-2 w-2 rounded-full bg-muted-foreground mr-3"></div>
                    <span>Professional image</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="text-center">
              <Link to="/signup">
                <Button className="bg-primary hover:bg-primary/80 text-primary-foreground font-medium px-8 py-6 text-lg">
                  Get Started
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
